



















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import UtxoRowInput from '@/components/Transaction/UtxoRowInput.vue'
import UtxoRowOutput from '@/components/Transaction/UtxoRowOutput.vue'
import {
    Transaction,
    getTransactionOutputs,
    getTransactionInputs,
} from '../js/Transaction'
import { toAVAX } from '../helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import { getMappingForType } from '@/store/modules/transactions/maps'

@Component({
    components: {
        UtxoRowInput,
        UtxoRowOutput,
        Tooltip,
        CopyText,
    },
    filters: {
        getType: getMappingForType,
        toAVAX,
    },
})
export default class TransactionUTXO extends Vue {
    @Prop() tx!: Transaction

    get inputs() {
        return getTransactionInputs(this.tx.inputs)
    }

    get outputs() {
        return getTransactionOutputs(this.tx.outputs)
    }

    get assets(): any {
        return this.$store.state.assets
    }

    get isAssetGenesis(): boolean {
        return this.tx.type === 'create_asset'
    }
}
